module.exports = __webpack_public_path__ + "img/zoomMeeting.98e28983.png";